<section style="height: 50px">
    <section style="margin: 1rem">
        <h3 style="font-weight: bolder; margin-top: 0px !important;">Contact us</h3>
    </section>
    <hr style="border-top: 2px solid #eee">
</section>
<section class="support-scroll">
    <section style="margin: 1rem">
        <h4 style="font-weight: bolder">Talk to one of the team</h4>
        <span>We're here to help and answer any questions you may have.</span>
    </section>
    <hr style="border-top: 2px solid #eee">
    <section style="margin: 1rem">
        <h5 style="font-weight: bolder">Email your question(s) to</h5>
        <a href="mailto:{{mailto}}?subject={{emailSubject}}&body={{emailMassage}}" id="supportEmail"
           style="color: #0a6aa1; text-decoration: underline !important;">{{mailto}}</a>
        <h5 style="font-weight: bolder">Telephone Support is available 24x7</h5>
        <ul>
            <li *ngFor="let supportTel of supportTels;"
                style="display: list-item !important; float: none !important;">
                <span class="country" style="color: #abaaaa">{{supportTel.country}}</span><br>
                <span class="tel"
                      style="display:block; text-align: center; font-weight: bold; margin: 10px">{{supportTel.tel}}</span>
            </li>
            <br>
        </ul>
        <small style="color: #969494; font-size: smaller;">For the numbers listed above that include Country Codes
            in parentheses, not all countries or regions are the same, so if you experience an issue with dialing
            the number for your region using the Country Code prefix, please try again to connect without dialing
            the prefix.</small>
        <br>
<!--        <div class="ticket">-->
<!--            <span style="color: #969494">Create a ticket</span>-->
<!--        </div>-->
<!--        <section style="position: relative;z-index: 100">-->
<!--            <div *ngFor="let supportChannel of supportChannels; let i = index" class="portal">-->
<!--                <button (click)="philipsServiceportal(i)" class="supportChannel">{{supportChannel.name}}</button>-->
<!--            </div>-->
<!--        </section>-->
    </section>
</section>
